import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useCrmFieldDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { fieldId: number; leadId?: number }) => {
      const res = await $api.delete(`/v1/crm/field/${data?.fieldId}`);

      return res?.data?.data;
    },
    {
      onSuccess: (_, { leadId }) => {
        qc.invalidateQueries([queryNames.CRM_FIELDS]);
        qc.invalidateQueries([crmConstants.queryKeys.LEAD_FILTER_PARAMS]);
        if (leadId) {
          qc.invalidateQueries([queryNames.LEAD_COMPLETED_DATA, leadId]);
          qc.invalidateQueries([queryNames.CRM_ONE_LID, leadId]);
        }
      }
    }
  );
};
